<template>
    <div>
        <h2>{{ accessoryFeatures.title }}</h2>

        <div id="anchor-technical-sheet" class="row">
            <template v-if="isFirstParty">
                <!--/* Affichage en grille pour les accessoires first party */-->
                <div
                    v-for="(feature, index) in accessoryFeatures.technicalFeatures"
                    :key="'technical-feature-'+ index"
                    class="mb-2 mb-md-3"
                    :class="index === 0 ? 'col-12' : 'col-12 col-md-6'"
                >
                    <p class="lead fw-bold mb-0">
                        {{ feature.title }}
                    </p>
                    <span class="text-mw standard text-break" v-html="feature.text" />
                </div>
            </template>

            <template v-else>
                <!--/* Affichage en tableau pour les accessoires third party,
                mais géré sous forme de liste pour l'accessibilité */-->
                <ul class="list-unstyled">
                    <li v-for="(feature, index) in accessoryFeatures.technicalFeatures" :key="index" class="list-item">
                        <div v-msh-html="feature.title" class="list-item-title" />
                        <div v-msh-html="feature.text" class="list-item-text" />
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        accessoryFeatures: {
            type: Object,
            required: true,
        },
        isFirstParty: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_colors';
@import 'ob1_common';
@import 'ob1_variables';

.list-item {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid $white;
}

.list-item-title {
    background-color: $gray4;
    padding: px-to-rem(12) px-to-rem(20);
    width: 35%;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 20%;
    }
}

.list-item-text {
    background-color: $gray2;
    padding: px-to-rem(10) px-to-rem(20);
    vertical-align: middle;
    display: flex;
    align-items: center;
    width: 65%;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 80%;
    }
}

</style>
